import { createSlice, nanoid, type PayloadAction } from "@reduxjs/toolkit";

import type { CorporateAccount } from "@/types/api";

interface CorporateAccountsState {
  items: CorporateAccount[];
}

const seed: CorporateAccount[] = [
  {
    id: "ca-1",
    name: "Mickey Travel",
    sfm_account_id: "DLR-00012",
    payment_terms: "monthly net 30",
    active: true,
  },
  {
    id: "ca-2",
    name: "BlueWave Tours",
    sfm_account_id: "DLR-00013",
    payment_terms: "monthly net 45",
    active: true,
  },
  {
    id: "ca-3",
    name: "Sunshine Holidays",
    sfm_account_id: "DLR-00014",
    payment_terms: "monthly net 30",
    active: false,
  },
];

const initialState: CorporateAccountsState = { items: seed };

export type CorporateAccountInput = Omit<CorporateAccount, "id">;

const slice = createSlice({
  name: "corporateAccounts",
  initialState,
  reducers: {
    addAccount(state, action: PayloadAction<CorporateAccountInput>) {
      const id = `ca-${nanoid(6)}`;
      state.items.unshift({ ...action.payload, id });
    },
    updateAccount(
      state,
      action: PayloadAction<{ id: string; patch: Partial<CorporateAccount> }>,
    ) {
      const row = state.items.find((r) => r.id === action.payload.id);
      if (row) Object.assign(row, action.payload.patch);
    },
    toggleActive(state, action: PayloadAction<string>) {
      const row = state.items.find((r) => r.id === action.payload);
      if (row) row.active = !row.active;
    },
    deleteAccount(state, action: PayloadAction<string>) {
      state.items = state.items.filter((r) => r.id !== action.payload);
    },
  },
});

export const { addAccount, updateAccount, toggleActive, deleteAccount } =
  slice.actions;
export default slice.reducer;
